<template>
    <div></div>
</template>

<script>
    export default {
        name: "Login",
        created() {
            this.login();
        },
        methods: {
            async login() {
                let res = await this.$axios.get(`/applycheck/rightlist`);
                this.$store.commit('setNotaryRights', res.data.rights);
                this.$store.commit('setNotaryInfo', {
                    ...res.data,
                    registerTime: res.data.registerTime.substr(0,10),
                });
                this.$router.replace('/apply');
            }
        }
    }
</script>

<style scoped>

</style>